import React, { useEffect, useRef, useState } from 'react'
import DashboardStyle from '../Dashboard'
import Button from '../../../components/Button'
import api, { customFuncsApi } from '../../../api'
import { get } from 'lodash'
import { ErrorModal } from '../../../components/Modal'
import ClipLoader from 'react-spinners/ClipLoader'
import moment from 'moment'
import { useSelector } from 'react-redux'
import ViewAccountModal from '../../../components/Modal/ViewAccountModal'
import { formatNumberWithIntl } from '../../../utils/formatNumber'
import EyeIcon2 from '../../../assets/icons/EyeIcon2'
import DashboardCard from '../../../components/Card/DashboardCard/index'
import { FaUserAlt, FaMoneyBill } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { BG_COLOR } from '../../../constants/colors'

const Tab1 = () => {
	const errorRef = useRef()
	const viewAccountModalRef = useRef()
	const navigate = useNavigate()

	const { getMe, roleAccess } = useSelector((state) => state.main)
	const role = getMe?.Department2?.Name
	console.log('getMe', getMe)
	console.log('roleAccess', roleAccess)

	const isFilterWhs = roleAccess?.U_MainFilterWHS === 'Y'
	const isFilterCash = roleAccess?.U_MainFilterCash === 'Y'

	const [isLoading, setIsLoading] = useState({
		loadingDebitCredit: false,
		loadingPurchases: false,
		loadingSold: false,
		loadingActiveClients: false,
		loadingInvoiceDebts: false,
		loadingInvoiceTotalPaid: false,
		loadingOverdueBalance: false,
		loadingOverdueSum: false,
	})
	const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'))
	const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'))
	const [startTable2Date, setStartTable2Date] = useState(
		moment().format('YYYY-MM-DD'),
	)
	const [endTable2Date, setEndTable2Date] = useState(
		moment().format('YYYY-MM-DD'),
	)
	const [startTimeFromMonth] = useState(
		moment().startOf('month').format('YYYY-MM-DD'),
	)
	const [endTimeFromMonth] = useState(moment().format('YYYY-MM-DD'))
	const [data, setData] = useState({
		data: [],
	})
	const [nextMonthStart] = useState(
		moment().add(1, 'month').startOf('month').format('YYYY-MM-DD'),
	)

	const [pageSold, setPageSold] = useState(0)
	const [pagePurchased, setPagePurchased] = useState(0)
	const [purchasedData, setPurchasedData] = useState({
		data: [],
		currentPage: 0,
	})
	// const [dailyAccountStats, setDailyAccountStats] = useState([])
	const [balanceMoney, setBalanceMoney] = useState([])
	const [balanceLoading, setBalanceLoading] = useState(false)
	const [activeClientsCount, setActiveClientsCount] = useState({})
	const [invoiceDebts, setInvoiceDebts] = useState({})
	const [invoiceTotalPaid, setInvoiceTotalPaid] = useState({})
	const [overdueBalance, setOverdueBalance] = useState({})
	const [overdueTotal, setOverdueTotal] = useState({})

	const BalanceMoney = async () => {
		setBalanceLoading(true)

		const conditions = []

		const cashAccounts = getMe?.U_MainViewCash?.split(',')

		const cashConditions = cashAccounts.map((acc) => `Code eq '${acc}'`)

		// add to existing conditions
		conditions.push(`(${cashConditions.join(' or ')})`)

		const filterCondition = conditions.length ? conditions.join(' or ') : ''

		const data = await api
			.get(
				`ChartOfAccounts?$filter=${
					isFilterCash ? filterCondition : `CashAccount eq 'tYES'`
				}`,
				{
					headers: { Prefer: 'odata.maxpagesize=10000' },
				},
			)
			.then((res) => JSON.parse(res.data).value)

		setBalanceMoney(data)
		setBalanceLoading(false)
	}

	const sold = () => {
		setIsLoading((prev) => ({ ...prev, loadingSold: true }))
		customFuncsApi(
			`xsSql/getLastInitialPayments?date1='${startDate + ' 00:00:00.000Z'}'&date2='${endDate + ' 00:00:00.000Z'}'&$skip=${pageSold}${isFilterWhs ? `&WhsCode='${getMe?.U_Warehouse}'` : ''}`,
			{
				headers: {
					Prefer: 'odata.maxpagesize=10',
				},
			},
		)
			.then((res) => {
				const resData = res.data.value
				setData({ data: [...resData] })
			})
			.catch((err) => {
				// errorRef.current?.open(
				//   get(JSON.parse(err.response.data), 'error.message', ''),
				// )
			})
			.finally(() => {
				setIsLoading((prev) => ({ ...prev, loadingSold: false }))
			})
	}

	const purchased = () => {
		setIsLoading((prev) => ({ ...prev, loadingPurchases: true }))
		customFuncsApi(
			`xsSql/getLastPurchases?date1='${startTable2Date + ' 00:00:00.000Z'}'&date2='${endTable2Date + ' 00:00:00.000Z'}'&$skip=${pagePurchased}${isFilterWhs ? `&WhsCode='${getMe?.U_Warehouse}'` : ''}`,
			{
				headers: {
					Prefer: 'odata.maxpagesize=10',
				},
			},
		)
			.then((res) => {
				const resData = res.data.value
				setPurchasedData({ data: [...resData] })
			})
			.catch((err) => {
				// errorRef.current?.open(
				//   get(JSON.parse(err.response.data), 'error.message', ''),
				// )
			})
			.finally(() => {
				setIsLoading((prev) => ({ ...prev, loadingPurchases: false }))
			})
	}

	const getActiveClientsCount = () => {
		setIsLoading((prev) => ({ ...prev, loadingActiveClients: true }))
		customFuncsApi(
			`xsSql/getActiveClientsCount?${isFilterWhs ? `&whsCode='${getMe?.U_Warehouse}'` : ''}`,
			{
				headers: {
					Prefer: 'odata.maxpagesize=10',
				},
			},
		)
			.then((res) => {
				const resData = res.data.value
				setActiveClientsCount(resData[0])
				console.log('Active Clients Count:', resData[0])
			})
			.catch((err) => {})
			.finally(() => {
				setIsLoading((prev) => ({ ...prev, loadingActiveClients: false }))
			})
	}
	const getInvoiceTotalDebts = () => {
		setIsLoading((prev) => ({ ...prev, loadingInvoiceDebts: true }))
		customFuncsApi(
			`xsSql/getInvoiceTotalDebts?startDate='${startTimeFromMonth + ' 00:00:00.000Z'}'&endDate='${endTimeFromMonth + ' 00:00:00.000Z'}'&${isFilterWhs ? `&whsCode='${getMe?.U_Warehouse}'` : ''}&$skip=${0}`,
			{
				headers: {
					Prefer: 'odata.maxpagesize=100',
				},
			},
		)
			.then((res) => {
				const resData = res.data.value
				setInvoiceDebts(resData[0])
			})
			.catch((err) => {
				console.error('Error fetching active clients count:', err)
			})
			.finally(() => {
				setIsLoading((prev) => ({ ...prev, loadingInvoiceDebts: false }))
			})
	}
	const getInvoiceTotalPaids = () => {
		setIsLoading((prev) => ({ ...prev, loadingInvoicePaid: true }))
		customFuncsApi(
			`xsSql/getInvoiceTotalPaids?startDate='${startTimeFromMonth + ' 00:00:00.000Z'}'&endDate='${endTimeFromMonth + ' 00:00:00.000Z'}'&${isFilterWhs ? `&whsCode='${getMe?.U_Warehouse}'` : ''}&$skip=${0}`,
			{
				headers: {
					Prefer: 'odata.maxpagesize=10',
				},
			},
		)
			.then((res) => {
				const resData = res.data.value
				setInvoiceTotalPaid(resData[0])
			})
			.catch((err) => {
				console.error('Error fetching active clients count:', err)
			})
			.finally(() => {
				setIsLoading((prev) => ({ ...prev, loadingInvoicePaid: false }))
			})
	}
	const getOverdueBalanceCount = () => {
		setIsLoading((prev) => ({ ...prev, loadingOverdue: true }))
		customFuncsApi(
			`xsSql/getOverdueBalanceCount?${isFilterWhs ? `&WhsCode='${getMe?.U_Warehouse}'` : ''}`,
			{
				headers: {
					Prefer: 'odata.maxpagesize=10',
				},
			},
		)
			.then((res) => {
				const resData = res.data.value
				setOverdueBalance(resData[0])
			})
			.catch((err) => {
				console.error('Error fetching active clients count:', err)
			})
			.finally(() => {
				setIsLoading((prev) => ({ ...prev, loadingOverdue: false }))
			})
	}
	const getOverdueBalanceSum = () => {
		setIsLoading((prev) => ({ ...prev, loadingOverdueSum: true }))
		customFuncsApi(
			`xsSql/getInvoiceTotalOverdue?dueDate=${nextMonthStart}&${isFilterWhs ? `&WhsCode='${getMe?.U_Warehouse}'` : ''}`,
			{
				headers: {
					Prefer: 'odata.maxpagesize=10',
				},
			},
		)
			.then((res) => {
				const resData = res?.data?.value
				setOverdueTotal(resData[0])
			})
			.catch((err) => {
				console.error('Error fetching active clients count:', err)
			})
			.finally(() => {
				setIsLoading((prev) => ({ ...prev, loadingOverdueSum: false }))
			})
	}

	useEffect(() => {
		BalanceMoney()
	}, [])

	useEffect(() => {
		// fetchDailyAccountStats()
		getActiveClientsCount()
		getInvoiceTotalDebts()
		getInvoiceTotalPaids()
		getOverdueBalanceCount()
		getOverdueBalanceSum()
	}, [startDate, endDate])

	useEffect(() => {
		purchased()
	}, [startTable2Date, endTable2Date, pagePurchased])

	useEffect(() => {
		sold()
	}, [pageSold, startDate, endDate])

	const newDatas = (table) => {
		if (table === 'sold') {
			if (data.data.length < 10) {
				alert('boshqa malumot yoq')
			} else setPageSold((prev) => prev + 10)
		} else {
			if (purchasedData.data.length < 10) {
				alert('boshqa malumot yoq')
			} else setPagePurchased((prev) => prev + 10)
		}
	}

	const oldData = (table) => {
		if (table === 'sold' && pageSold <= 0) {
			alert('boshqa malumot yoq')
		} else if (table === 'purchased' && pagePurchased <= 0) {
			alert('boshqa malumot yoq')
		} else {
			table === 'sold'
				? setPageSold((prev) => prev - 10)
				: setPagePurchased((prev) => prev - 10)
		}
	}

	const handleStartDateChange = (event) => {
		setStartDate(event.target.value)
	}

	const handleEndDateChange = (event) => {
		setEndDate(event.target.value)
	}

	const dashboardCardData = [
		role !== 'Sherik' && {
			title: 'Jami faol mijozlar',
			price: activeClientsCount.Unique_Open_AR_Invoice_Customers || 0,
			icon: <FaUserAlt size={16} className="text-blue-600" />,
			iconBgColor: 'blue-300',
			isLoading: isLoading.loadingActive,
			onNavigate: () => {
				navigate('/clients', { state: { status: 'Active' } })
			},
		},
		role !== 'Sherik' && {
			title: 'Umumiy qarzdorlik',
			price: invoiceDebts?.TotalDebt || 0,
			icon: <FaUserAlt size={16} className="text-red-600" />,
			iconBgColor: 'red-300',
			priceColor: 'text-red-600',
			isLoading: isLoading.loadingInvoiceDebts,
		},
		role !== 'Sherik' && {
			title: "Umumiy to'langan summa",
			price: invoiceTotalPaid.TotalPaid || 0,
			icon: <FaMoneyBill size={20} className="text-green-600" />,
			iconBgColor: 'green-300',
			priceColor: 'text-green-600',
			isLoading: isLoading.loadingInvoiceTotalPaid,
		},
		role !== 'Sherik' && {
			title: "Muddati o'tgan qarzdorlik soni",
			price: overdueBalance?.OverdueInvoiceCount || 0,
			icon: <FaMoneyBill size={20} className="text-orange-600" />,
			iconBgColor: 'orange-300',
			priceColor: 'text-orange-600',
			isLoading: isLoading.loadingOverdueBalance,
		},
		role !== 'Sherik' && {
			title: "Muddati o'tgan qarzdorlik summasi",
			price: overdueTotal?.TotalOverdueAmount || 0,
			icon: <FaMoneyBill size={20} className="text-orange-600" />,
			iconBgColor: 'orange-300',
			priceColor: 'text-orange-600',
			isLoading: isLoading.loadingOverdueBalance,
		},
	].filter(Boolean)

	return (
		<DashboardStyle
			style={{
				backgroundColor: BG_COLOR,
			}}
		>
			<div className="container">
				<div className="flex flex-col gap-4  ">
					<div className="grid grid-cols-2 lg:grid-cols-2  gap-4   mt-5">
						{dashboardCardData.map((item, index) => (
							<DashboardCard key={index} data={item} />
						))}
					</div>
					<h4 className={'font-bold text-lg text-center mt-5 mb-4'}>
						Информация о кассе
					</h4>
					{isLoading.loadingDebitCredit || balanceLoading ? (
						<ClipLoader
							loading={true}
							size={20}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<div className="max-h-[50vh] overflow-y-scroll w-full border-[1px] border-black">
							<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
								<thead className="text-xs text-gray-700 uppercase bg-gray-50  sticky top-0">
									<th scope="col" className="px-6 py-4">
										Счет
									</th>
									<th scope="col" className="px-6 py-4">
										Название
									</th>
									<th scope="col" className="px-6 py-4">
										Баланс
									</th>
									<th scope="col" className="px-6 py-4">
										Валюта
									</th>
									<th scope="col" className="px-6 py-4">
										Действие
									</th>
								</thead>
								<tbody>
									{balanceMoney.length ? (
										balanceMoney.map((v, i) => {
											return (
												<tr
													className="bg-white border-b  hover:bg-gray-50 "
													key={i}
												>
													<td
														scope="row"
														className="px-6 py-4 font-medium text-gray-900 "
													>
														{v.Code}
													</td>
													<td
														scope="row"
														className="px-6 py-4 font-medium text-gray-900 "
													>
														{v.Name}
													</td>
													<td
														scope="row"
														className="px-6 py-4 font-medium text-gray-900 "
													>
														{v.AcctCurrency === 'UZS'
															? formatNumberWithIntl(v.Balance_FrgnCurr)
															: formatNumberWithIntl(v.Balance)}
													</td>
													<td
														scope="row"
														className="px-6 py-4 font-medium text-gray-900 "
													>
														{v.AcctCurrency}
													</td>
													<td
														scope="row"
														className="px-6 py-4 font-medium text-gray-900"
													>
														<Button
															onClick={() => {
																viewAccountModalRef.current?.open({
																	startDate: moment().format('YYYY-MM-DD'),
																	endDate: moment().format('YYYY-MM-DD'),
																	accCode: v.Code,
																	accName: v.Name,
																})
															}}
															className="!w-8 !h-10"
														>
															<EyeIcon2 />
														</Button>
													</td>
												</tr>
											)
										})
									) : (
										<p className="px-6 py-4 font-medium text-gray-900 ">
											Счет нету
										</p>
									)}
								</tbody>
							</table>
						</div>
					)}
				</div>

				<div className="w-full flex items-center gap-2 mt-8">
					<div className="flex flex-col gap-1">
						<label className="text-sm font-medium">Дата начала</label>
						<input
							type="date"
							value={startDate}
							onChange={handleStartDateChange}
							className="border border-gray-300 rounded px-2 py-1"
						/>
					</div>
					<div className="flex flex-col gap-1">
						<label className="text-sm font-medium">Дата окончания</label>
						<input
							type="date"
							value={endDate}
							onChange={handleEndDateChange}
							className="border border-gray-300 rounded px-2 py-1"
						/>
					</div>
				</div>
				<div>
					<h4 className={'font-bold text-lg text-center mt-10 mb-4'}>
						Продано
					</h4>
					{isLoading.loadingSold ? (
						<div style={{ display: 'flex', justifyContent: 'center' }}>
							<ClipLoader
								loading={true}
								size={20}
								aria-label="Loading Spinner"
								className={'loader'}
								data-testid="loader"
							/>
						</div>
					) : (
						<div className="overflow-y-auto mb-8">
							<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
								<thead className="text-xs text-gray-700 uppercase bg-gray-50  ">
									<tr>
										<th scope="col" className="px-6 py-4">
											Товар
										</th>
										<th scope="col" className="px-6 py-4">
											Дата продажи
										</th>
										<th scope="col" className="px-6 py-4">
											IMEI
										</th>
										<th scope="col" className="px-6 py-4">
											Взнос
										</th>
										<th scope="col" className="px-6 py-4">
											Итого
										</th>
									</tr>
								</thead>
								<tbody>
									{data.data.map((v, i) => {
										return (
											<tr
												key={i}
												className="bg-white border-b  hover:bg-gray-50 "
											>
												<td
													scope="row"
													className="px-6 py-4 font-medium text-gray-900 "
												>
													{v.Dscription}
												</td>
												<td className="px-6 py-4">
													{v.DocDate && moment(v.DocDate).format('DD-MM-YYYY')}
												</td>{' '}
												<td className="px-6 py-4">{v.IntrSerial || '-'}</td>
												<td className="px-6 py-4">
													{v.SumApplied && formatNumberWithIntl(v.SumApplied)}
												</td>
												<td className="px-6 py-4">
													{v.DocTotal && formatNumberWithIntl(v.DocTotal)}
												</td>
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
					)}

					<div className="topCard">
						<div className="flex">
							<Button
								disabled={pageSold === 0}
								className={'btn'}
								onClick={() => oldData('sold')}
								btnStyle={{ marginRight: 10 }}
							>
								{'<'}
							</Button>
							<Button
								disabled={data.data.length < 10}
								className={'btn'}
								onClick={() => newDatas('sold')}
							>
								{'>'}
							</Button>
						</div>
					</div>
				</div>

				<div className="mt-10">
					<div className="w-full flex items-center gap-2 mt-8">
						<div className="flex flex-col gap-1">
							<label className="text-sm font-medium">Дата начала</label>
							<input
								type="date"
								value={startTable2Date}
								onChange={(e) => setStartTable2Date(e.target.value)}
								className="border border-gray-300 rounded px-2 py-1"
							/>
						</div>
						<div className="flex flex-col gap-1">
							<label className="text-sm font-medium">Дата окончания</label>
							<input
								type="date"
								value={endTable2Date}
								onChange={(e) => setEndTable2Date(e.target.value)}
								className="border border-gray-300 rounded px-2 py-1"
							/>
						</div>
					</div>
					<h4 className={'font-bold text-lg text-center mt-10 mb-4'}>
						Куплено
					</h4>
					{isLoading.loadingPurchases ? (
						<div style={{ display: 'flex', justifyContent: 'center' }}>
							<ClipLoader
								loading={true}
								size={20}
								aria-label="Loading Spinner"
								className={'loader'}
								data-testid="loader"
							/>
						</div>
					) : (
						<div className="overflow-y-auto mb-8">
							<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
								<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
									<tr>
										<th scope="col" className="px-6 py-4">
											Товар
										</th>
										<th scope="col" className="px-6 py-4">
											Дата покупки
										</th>
										<th scope="col" className="px-6 py-4">
											IMEI
										</th>
										<th scope="col" className="px-6 py-4">
											Итого
										</th>
										<th scope="col" className="px-6 py-4">
											Покупатель
										</th>
										<th scope="col" className="px-6 py-4">
											Количество
										</th>
										<th scope="col" className="px-6 py-4">
											Склад
										</th>
									</tr>
								</thead>
								<tbody>
									{purchasedData.data.map((v, i) => {
										return (
											<tr
												key={i}
												className="bg-white border-b  hover:bg-gray-50 "
											>
												<td
													scope="row"
													className="px-6 py-4 font-medium text-gray-900 "
												>
													{v.Dscription}
												</td>
												<td className="px-6 py-4">
													{v.DocDate && moment(v.DocDate).format('DD-MM-YYYY')}
												</td>
												<td className="px-6 py-4">{v.IntrSerial || '-'}</td>
												<td className="px-6 py-4">
													{v.DocTotal && formatNumberWithIntl(v.DocTotal)}
												</td>
												<td className="px-6 py-4">{v.CardName}</td>
												<td className="px-6 py-4">
													{formatNumberWithIntl(v.Quantity)}
												</td>
												<td className="px-6 py-4">{v.WhsCode}</td>
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
					)}

					<div className="topCard">
						<div className="flex">
							<Button
								disabled={pagePurchased === 0}
								className={'btn'}
								onClick={() => oldData('purchased')}
								btnStyle={{ marginRight: 10 }}
							>
								{'<'}
							</Button>
							<Button
								disabled={purchasedData.data.length < 10}
								className={'btn'}
								onClick={() => newDatas('purchased')}
							>
								{'>'}
							</Button>
						</div>
					</div>
				</div>
			</div>
			<>
				<ErrorModal
					getRef={(r) => {
						errorRef.current = r
					}}
				/>
				<ViewAccountModal
					getRef={(r) => {
						viewAccountModalRef.current = r
					}}
				/>
			</>
		</DashboardStyle>
	)
}

export default Tab1
